module.exports = __webpack_public_path__ + "static/img/img_t1.5e15e939.webp";